<script lang="ts">
  // Смена собственного пароля. При forced=true закрыть нельзя — так мы
  // не даём пользоваться системой с выданным «временным» паролем.
  import { changePassword } from '../lib/api';

  type Props = {
    /** Пароль выдан администратором и должен быть заменён прямо сейчас. */
    forced?: boolean;
    onsuccess: () => void;
    onclose?: () => void;
  };
  let { forced = false, onsuccess, onclose }: Props = $props();

  const MIN = 12;

  let oldPw = $state('');
  let newPw = $state('');
  let confirmPw = $state('');
  let err = $state('');
  let busy = $state(false);

  async function submit(e: Event): Promise<void> {
    e.preventDefault();
    err = '';
    if (newPw.length < MIN) {
      err = `Новый пароль — минимум ${MIN} символов`;
      return;
    }
    if (newPw !== confirmPw) {
      err = 'Пароли не совпадают';
      return;
    }
    if (newPw === oldPw) {
      err = 'Новый пароль совпадает со старым';
      return;
    }
    busy = true;
    try {
      await changePassword(oldPw, newPw);
      onsuccess();
    } catch (e2) {
      err = e2 instanceof Error ? e2.message : String(e2);
    } finally {
      busy = false;
    }
  }

  function onKeydown(e: KeyboardEvent): void {
    if (e.key === 'Escape' && !forced) onclose?.();
  }
</script>

<svelte:window onkeydown={onKeydown} />

<div
  class="bg"
  onclick={(e) => {
    if (!forced && e.target === e.currentTarget) onclose?.();
  }}
  role="presentation"
>
  <form class="modal" onsubmit={submit}>
    <h2>{forced ? 'Задайте свой пароль' : 'Смена пароля'}</h2>
    {#if forced}
      <p class="muted">
        Вы вошли с временным паролем. Придумайте свой — до этого работать с камерами нельзя.
      </p>
    {/if}

    <label>
      Текущий пароль
      <input type="password" bind:value={oldPw} autocomplete="current-password" required />
    </label>
    <label>
      Новый пароль (от {MIN} символов)
      <input type="password" bind:value={newPw} autocomplete="new-password" required />
    </label>
    <label>
      Ещё раз
      <input type="password" bind:value={confirmPw} autocomplete="new-password" required />
    </label>

    <p class="hint">После смены все другие входы в аккаунт будут завершены.</p>
    <div class="err">{err}</div>

    <div class="actions">
      {#if !forced}
        <button type="button" class="ghost" onclick={() => onclose?.()}>Отмена</button>
      {/if}
      <button type="submit" class="primary" disabled={busy}>
        {busy ? 'Сохраняю…' : 'Сохранить'}
      </button>
    </div>
  </form>
</div>

<style>
  .bg {
    position: fixed; inset: 0; z-index: 300;
    background: rgba(0,0,0,.45);
    backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px);
    display: flex; align-items: center; justify-content: center;
  }
  .modal {
    width: min(420px, calc(100vw - 32px));
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 24px;
    display: flex; flex-direction: column; gap: 14px;
  }
  h2 { font-size: 17px; font-weight: 600; letter-spacing: -.01em; margin: 0; }
  .muted { color: var(--fg-muted); margin: 0; font-size: 13px; line-height: 1.4; }
  label { display: flex; flex-direction: column; gap: 4px; font-size: 12px; color: var(--fg-muted); font-weight: 500; }
  input { padding: 8px 10px; border-radius: 8px; border: 1px solid var(--border); background: var(--bg-elev); color: var(--fg); }
  input:focus { outline: 2px solid var(--accent); outline-offset: -1px; border-color: var(--accent); }
  .hint { color: var(--fg-muted); font-size: 12px; margin: 0; }
  .err { color: var(--bad); font-size: 13px; min-height: 1.2em; }
  .actions { display: flex; gap: 10px; justify-content: flex-end; }
  button.primary { background: var(--accent); color: #fff; padding: 8px 14px; border-radius: 8px; font-weight: 500; }
  button.primary:hover { filter: brightness(1.08); }
  button.primary:disabled { opacity: .6; }
  button.ghost { color: var(--fg-muted); padding: 8px 14px; border-radius: 8px; font-weight: 500; }
  button.ghost:hover { color: var(--fg); }
</style>
